import React from 'react';
import Framework from "@beardeddevops/react.framework";
import API from "@beardeddevops/react.api";
import Types from "../../constants/Types";
import ObjectOverride from "components/ObjectOverride";;
import UpgradesList from '../Parts/UpgradesList';
import ModulesList from "../Parts/ModulesList";
import HardwareList from "../Parts/HardwareList";
import ServicesList from "../Parts/ServicesList";
import LocationsList from "../Parts/LocationsList";

/**
 *  @property {Locations_Modules_Object|Locations_Modules_Is} state
 *  @property {object} model
 *  @property {Locations_Modules_Properties} model.properties
 *  @property {Locations_Modules_Is} model.is
 *  @property {Locations_Modules_Has} model.has
 */
class MarketPlace extends ObjectOverride {
	constructor(props) {
		super(props, Types.Locations_Modules._name);
		this.loadSubscriptions().then();
		this.loadModules().then();
		this.loadUpgrades().then();
		this.loadAccountModules().then();
		this.loadServices().then();
		const resolvedLocation = this.resolveActiveLocation(props.rootState);
		this.state.location = resolvedLocation?.pkey ?? null;
		this.state.location_binary_id = resolvedLocation?.binary_id ?? null;
		this.state.locations = props.rootState.locations;
		this.state.previousLocation = null;
		this.state.subscriptionUsage = null;
		this.state.subscriptionUsageLoading = false;
		this.state.subscriptionUsageError = false;
		this.updateSelectedActualLocation(this.state.location);
	}

	resolveActiveLocation = (rootState = this.props.rootState) => {
		const locations = rootState.locations || [];
		const firstActiveLocation = locations.find(location => !location.archived);
		const selectedActiveLocation = locations.find(
			location => location.pkey === rootState.locationSelected && !location.archived
		);
		return selectedActiveLocation ?? firstActiveLocation ?? null;
	}

	updateSelectedActualLocation = (locationPkey) => {
		this.state.selectedActualLocation = this.props.rootState.locations.filter(function(location){
			if(location.pkey === locationPkey){
				return location;
			}
		})
		this.setState({selectedActualLocation: this.state.selectedActualLocation});
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);
		if(prevState.location !== this.state.location){
			if (this.props.rootState.locationSelected !== this.state.location) {
				this.props.rootState.set({locationSelected: this.state.location, locationSelectedBinaryId: this.state.location_binary_id})
			}
			this.updateSelectedActualLocation(this.state.location);
			const selectedLocation = this.props.rootState.locations.find(location => location.pkey === this.state.location);
			this.loadSubscriptionUsage(selectedLocation).then();
		}
		//if subbing/unsubbing to a module, this catches it and updates the state
		if(prevState.selectedActualLocation.location_moduless !== this.state.selectedActualLocation.location_moduless){
			this.updateSelectedActualLocation(this.state.location);
		}
	}

	componentDidMount() {
		const resolvedLocation = this.resolveActiveLocation();
		if (!resolvedLocation) {
			return;
		}
		if (
			this.props.rootState.locationSelected !== resolvedLocation.pkey ||
			this.props.rootState.locationSelectedBinaryId !== resolvedLocation.binary_id
		) {
			this.props.rootState.set({
				locationSelected: resolvedLocation.pkey,
				locationSelectedBinaryId: resolvedLocation.binary_id
			});
		}
		if (
			this.state.location !== resolvedLocation.pkey ||
			this.state.location_binary_id !== resolvedLocation.binary_id
		) {
			this.setState({
				location: resolvedLocation.pkey,
				location_binary_id: resolvedLocation.binary_id
			});
			this.updateSelectedActualLocation(resolvedLocation.pkey);
		} else {
			this.loadSubscriptionUsage(resolvedLocation).then();
		}
	}

	loadSubscriptionUsage = async (location) => {
		if (!location) {
			this.setState({subscriptionUsage: null, subscriptionUsageLoading: false, subscriptionUsageError: false});
			return;
		}

		const requestLocationId = `${location.binary_id}-${location.pkey}`;
		this.subscriptionUsageRequest = requestLocationId;
		this.setState({subscriptionUsage: null, subscriptionUsageLoading: true, subscriptionUsageError: false});

		const dashboard = new API.BuildClass(Types.Dashboard._name, API.RequestType.READ);
		dashboard.parent = location.pkey;
		dashboard.parent_binary_id = location.binary_id;

		try {
			const subscriptionUsage = await dashboard.submit(null, API.RequestType.READ);
			if (this.subscriptionUsageRequest === requestLocationId) {
				this.setState({subscriptionUsage, subscriptionUsageLoading: false});
			}
		} catch (e) {
			if (this.subscriptionUsageRequest === requestLocationId) {
				this.setState({subscriptionUsage: null, subscriptionUsageLoading: false, subscriptionUsageError: true});
			}
		}
	}

	async loadSubscriptions() {
		let subscriptions = new API.BuildClass(Types.Subscriptions._name, API.RequestType.READ_ALL);
		let data = await subscriptions.submit(null, API.RequestType.READ_ALL)
		await this.setState({subscriptions: data});
	}

	async loadModules() {
		let modules = new API.BuildClass(Types.Modules._name, API.RequestType.READ_ALL);
		modules.limit = 1000;
		let data = await modules.submit(null, API.RequestType.READ_ALL)
		let security_module = null;
		let location_modules = data.items.filter((module) => {
			if(module.pkey === 3) {
				security_module = module;
				return false;
			}
			return true;
		})
		await this.setState({modules: location_modules, security_module: security_module});
	}

	async loadAccountModules() {
		let account_modules = new API.BuildClass(Types.Accounts_Modules._name, API.RequestType.READ_ALL);
		let data = await account_modules.submit(null, API.RequestType.READ_ALL);
		await this.setState({account_modules: data})
	}

	async loadUpgrades() {
		let account_modules = new API.BuildClass(Types.Upgrades._name, API.RequestType.READ_ALL);
		account_modules.order = 'asc';
		let data = await account_modules.submit(null, API.RequestType.READ_ALL);
		await this.setState({upgrades: data.items})
	}

	async loadServices() {
		let service_modules = new API.BuildClass(Types.Modules_Module_Services._name, API.RequestType.READ_ALL);
		let data = await service_modules.submit(null, API.RequestType.READ_ALL);
		await this.setState({services: data.items})
	}

	handleAfterSave = async () => {
		//calls details from the server to get modules
		await this.props.rootState.triggerAction('getUserInformation', null);

		//updates state from the rootState since it's not prop drilled in, and triggers componentDidUpdate
		const selectedLocation = this.resolveActiveLocation();
		this.updateSelectedActualLocation(selectedLocation.pkey);
		await this.loadSubscriptionUsage(selectedLocation);
	}

	scrollToSection = (event) => {
		event.preventDefault();
		const section = document.getElementById(event.currentTarget.hash.slice(1));
		if (section) {
			section.scrollIntoView({
				behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
				block: 'start'
			});
			section.focus({preventScroll: true});
		}
	}

	render() {
		let object = this.state;
		let properties = this.model.properties;
		const notArchivedLocations = this.props.rootState.locations.filter(location => !location.archived);
		const firstActiveLocation = notArchivedLocations[0];
		const selectedActiveLocation = notArchivedLocations.find(
			location => location.pkey === this.props.rootState.locationSelected
		) ?? null;
		const selectLocation = selectedActiveLocation ?? (object.location
			? notArchivedLocations.find(location => location.pkey === object.location)
			: null) ?? firstActiveLocation;

		const sections = [
			{id: 'marketplace-modules', label: 'Modules', visible: object.modules?.length > 0},
			{id: 'marketplace-upgrades', label: 'Upgrades', visible: object.upgrades?.length > 0},
			{id: 'marketplace-services', label: 'Services', visible: object.services?.length > 0},
			{id: 'marketplace-subscriptions', label: 'Location Subscriptions', visible: object.subscriptions?.items?.length > 0}
		].filter(section => section.visible);

		return (
			<div className={"container-fluid"}>
				<h2 style={{fontWeight: "bold"}}>FFL Boss Marketplace</h2>
				<div className={"row"}>
					<div className={"col-12 col-md-4 mb-3 mb-md-0"}><em>Explore Add-on Modules and Subscriptions to FFL Boss.</em></div>
					<div className={"col-12 col-md-8"}>
						<Framework.Elements.Select
							shouldLoad={true}
							objects={notArchivedLocations}
							value={selectLocation?.pkey}
							error={object.location_error}
							binary_id={selectLocation?.binary_id}
							property={properties.location}
							label={'Locations'}
							update={this.handleSelectPropertyUpdate}
							moduleClass={'marketPlaceSelect'}
							text={"name_display|name"}
						/>
					</div>
				</div>
				{sections.length > 0 ? (
					<nav aria-label="Marketplace sections" className="d-flex flex-wrap align-items-center mt-3">
						<span className="mr-2 mb-2 font-weight-bold">Go To:</span>
						{sections.map(section => (
							<a key={section.id} href={`#${section.id}`} onClick={this.scrollToSection}
								className="btn btn-outline-primary btn-sm rounded-pill mr-2 mb-2">
								{section.label}
							</a>
						))}
					</nav>
				) : null}
				<hr/>
				{/*Account/Location Modules*/}
				{this.state.modules?.length > 0 ? (
					<section id="marketplace-modules" tabIndex={-1} aria-label="Modules" style={{scrollMarginTop: 80}}>
						<ModulesList
							rootState={this.props.rootState}
							history={this.props.history}
							handleAfterSave={this.handleAfterSave}
							object={object}
						/>
					</section>
				) : null}

				{/*Upgrades*/}
				{this.state.upgrades?.length > 0 ? (
					<section id="marketplace-upgrades" tabIndex={-1} aria-label="Upgrades" style={{scrollMarginTop: 80}}>
						<UpgradesList
							rootState={this.props.rootState}
							handleAfterSave={this.handleAfterSave}
							object={object}
							history={this.props.history}
						/>
						<hr/>
					</section>
				) : null}

				{/*Services*/}
				{this.state.services?.length > 0 ? (
					<section id="marketplace-services" tabIndex={-1} aria-label="Services" style={{scrollMarginTop: 80}}>
						<ServicesList
							rootState={this.props.rootState}
							handleAfterSave={this.handleAfterSave}
							object={object}
							history={this.props.history}
						/>
					</section>
				) : null}

				{/*Location Subscriptions Section*/}
				{this.state.subscriptions?.items?.length > 0 ? (
					<section id="marketplace-subscriptions" tabIndex={-1} aria-label="Location Subscriptions" style={{scrollMarginTop: 80}}>
						<LocationsList
							object={object}
							history={this.props.history}
							rootState={this.props.rootState}
							handleAfterSave={this.handleAfterSave}
							subscriptionUsage={this.state.subscriptionUsage}
							subscriptionUsageLoading={this.state.subscriptionUsageLoading}
							subscriptionUsageError={this.state.subscriptionUsageError}
							reloadSubscriptionUsage={() => this.loadSubscriptionUsage(selectLocation)}
						/>
					</section>
				) : null}
			</div>
		);
	}
}

export default Framework.Components.withRootState(MarketPlace);
